/**
 * @format
 * @Description: 消息模板状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Utils from 'utils';
import { get, map } from 'lodash';

const CDN_BASE = 'assets';
useStrict(true);
class TaskManageMod {
  @observable
  addManageVisible = false;

  @observable
  isEdit = false;

  @observable
  editInfo = {};

  @observable
  version = 0;

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }

  getTaskListBeforeRequest = data => {
    const { status, bizName } = data;
    return {
      pageSize: data.pageSize,
      pageNum: data.pageNum,
      filter: {
        bizName,
        status,
        startTime: data.updateTime && data.updateTime[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime: data.updateTime && data.updateTime[1].format('YYYY-MM-DD HH:mm:ss'),
      }
    };
  };

  getTaskListAfterRequest = data => {
    map(get(data, 'list'), item => {
      item.status = item.status || 'ENABLE';
    });
    return data;
  };

  handleCancel() {
    this.updateStore({ addManageVisible: false });
  }

  saveFormBeforeRequest = data => {
    return data;
  };
}

// ES6单例写法
export default new TaskManageMod();



// WEBPACK FOOTER //
// ./src/pages/DispatchCenter/TaskManage/TaskManageMod.js